<template>
    <div class="main">
        <div class="title">
            <div class="name">专家审核</div>
        </div>
        <div class="tab">
            <span :class="{active : active === 0}" @click="active = 0">待审核</span>
            <span :class="{active : active === 2}" @click="active = 2">已拒绝</span>
        </div>
        <div class="list-box">
            <div class="search-box">
                <div class="select-box">
                    <el-select v-model="search.cate" clearable placeholder="请选择专家分类" @change="search.value = '',getExpertType">
                        <el-option
                            v-for="item in cate_lists"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="select-box">
                    <el-select v-model="search.value" class="margin-left-xs" clearable placeholder="请选择专家领域">
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="input-box">
                    <el-input v-model="search.input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
                    <div @click="list">
                        <i class="iconfont icon-sousuo"></i>
                        <span>搜索</span>
                    </div>
                </div>
                <div class="chongz" @click="reset">重置</div>
                <div class="chongz margin-left-xs" @click="exportInfo">导出</div>
            </div>
            <el-table
                :cell-style="{'text-align':'center'}"
                :data="tableData"
                :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
                border
                style="width: 100%;border-radius: 10px;">
                <el-table-column
                    label="序号"
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="专家姓名"
                    prop="name"
                    width="80">
                </el-table-column>
                <el-table-column
                    label="分类"
                    prop="cate_name"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="领域"
                    prop="type_text"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="职务"
                    prop="job_text"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="简介"
                    width="200">
                    <template slot-scope="scope">
                        <div class="ovHide3" v-html="scope.row.desc"></div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="照片"
                    width="90">
                    <template slot-scope="scope">
                        <img :src="urlStr + scope.row.pic" alt="" style="width: 65px;height: 77px;object-fit: scale-down">
                    </template>
                </el-table-column>
                <el-table-column
                    label="申请时间"
                    prop="create_time"
                    width="100">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button
                            class="del"
                            round
                            size="small"
                            @click="handleDelete(scope.row.id)">删除
                        </el-button>
                        <el-button
                            class="edit"
                            round
                            size="small"
                            type="primary"
                            @click="go(scope.row.id)">审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {catelist, expertDel, Expertlist, getExpertType} from "@/api/index";
import {baseURL, urlStr} from "@/config";

export default {
    name: "examine",
    data() {
        return {
            urlStr: urlStr,
            baseURL: baseURL,
            daochu: '/api/expert/exportToExcel?',
            active: 0,
            id: '',
            search: {
                value: '',
                cate: '',
                input: ''
            },
            cate_lists: [],
            options: [],
            tableData: []
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    created() {
        this.$emit("setActive", {
            active: 1,
            act: 1,
            name: '专家管理 > 专家审核'
        })
        this.init()
        this.getExpertType()
        this.list()
    },
    methods: {
        handleDelete(id) {
            this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.expertDel(id)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        go(id) {
            this.$router.push({
                path: '/home/examineDetail',
                query: {
                    id: id,
                    act: 1
                }
            })
        },

        // 获取列表
        async list() {
            let _res = await Expertlist(
                this.user.mid,
                '', '',
                this.active,
                this.search.value,
                this.search.cate,
                this.search.input,
                1, 10000
            );
            if (_res.status === 200) {
                this.tableData = _res.data
                _res.data.map(item => {
                    let ary = JSON.parse(item.job)
                    let arr = []
                    ary.map(itm => {
                        arr.push(itm.value)
                    })
                    item.job_text = arr.join('、')
                })
            } else {
                this.$message.error(_res.msg)
            }
        },
        async init() {
            let _data = await catelist(
                this.user.mid,
                1,
                999
            )
            this.cate_lists = _data.data
        },
        // 获取分类
        async getExpertType() {
            let _res = await getExpertType(
                this.user.mid,
                this.search.cate
            );
            if (_res.status === 200) {
                this.options = _res.data
            } else {
                this.$message.error(_res.msg);
            }
        },
        // 删除专家
        async expertDel(id) {
            let _res = await expertDel(
                this.user.mid,
                id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg);
                this.list()
            } else {
                this.$message.error(_res.msg);
            }
        },
        exportInfo(){
            window.open(baseURL + this.daochu + 'mid=' + this.user.mid+ '&search_type='+ this.search.value
                    +'&search_name=' + this.search.input + '&search_cate=' + this.search.cate + '&search_state=' + this.active)
        },
        reset() {
            this.search.value = ''
            this.search.cate = ''
            this.search.input = ''
            this.list()
        },
    },
    watch: {
        active() {
            this.list()
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>

.del {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    border: solid 1px #0a2240;
    line-height: 28px;
    padding: 0;
    color: #0a2240;
}

.edit {
    width: 70px;
    height: 30px;
    background-color: #0a2240;
    line-height: 28px;
    padding: 0;
    border-radius: 15px;
}

.main {
    display: flex;
    flex-direction: column;

    .title {
        padding: 5px 8px 15px 8px;

        .name {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
        }
    }

    .tab {
        width: 100%;
        display: flex;
        justify-content: space-between;

        span {
            width: 490px;
            height: 50px;
            border-radius: 10px;
            background: rgba(255, 255, 255, .3);
            font-size: 18px;
            color: #ffffff;
            font-weight: bold;
            text-align: center;
            line-height: 50px;
            cursor: pointer;

            &.active {
                background: rgba(255, 255, 255, 1);
                color: #ff9600;
                position: relative;
            }

            &.active:after {
                content: '';
                width: 12px;
                height: 12px;
                position: absolute;
                background-color: #ffffff;
                transform: rotate(45deg);
                bottom: -6px;
                left: 50%;
                margin-left: -6px;
            }
        }
    }

    .list-box {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px;
        margin-top: 20px;
        flex: 1;

        .search-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            .select-box {
                width: 162px;
            }

            .chongz {
                width: 99px;
                height: 40px;
                background-color: #0a2240;
                border-radius: 5px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
                text-align: center;
                line-height: 40px;
            }

            .input-box {
                flex: 1;
                width: 0;
                margin: 0 15px;
                display: flex;
                height: 40px;
                overflow: hidden;
                justify-content: space-between;
                border-radius: 5px;

                > div {
                    width: 100px;
                    height: 40px;
                    background-color: #0a2240;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    span {
                        font-size: 16px;
                        color: #ffffff;
                    }

                    i {
                        margin-right: 4px;
                        color: #ffffff;
                        font-size: 18px;
                    }
                }
            }
        }

    }
}
</style>


